import React from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { regexUrlMatch } from "../../../services/helpers/Helper";

const SubMenu = (props) => {
   const { subMenus } = props;
   const { menus, title } = subMenus;
   const location = useLocation();

   return (
      <React.Fragment>
         {menus && menus.length > 0 &&
            <div className="app-messaging-first--section-sub-menu--container">
               <div className="app-messaging-first--submenu--title">
                  {title}
               </div>
               <ul className="app-messaging-first--submenu--nav-list">
                  {menus.map((item, index) => {
                     return (
                        <li className="app-messaging-first--submenu-nav-link" key={index}>
                           <div className="app-messaging-first--submenu-nav-link-item">
                              <Link
                                 className={`app-messaging-first--submenu--active ${regexUrlMatch(item.match, location.pathname) && "active"}`}
                                 to={item.href}>
                              </Link>
                              <Link
                                 className={`app-messaging-first--submenu-nav-link-item-nav app-messaging-first--submenu--active ${regexUrlMatch(item.match, location.pathname) && "active"}`}
                                 to={item.href}>
                                 <div className="app-messaging-first--submenu-nav-link-item--wraper">
                                    <div className="app-messaging-first--submenu-nav-link-item--icon">
                                       {item.icon}
                                    </div>
                                    <div className="app-messaging-first--submenu-nav-link-item--title app-messaging-first--submenu--no-child">
                                       {item.name}
                                    </div>
                                 </div>
                              </Link>
                              {item.subMenus && item.subMenus.length > 0 &&
                                 <ul className="app-messaging-first--childmenu--nav-list">
                                    {item.subMenus.map((subItem, subIndex) => {
                                       return (
                                          <li className="app-messaging-first--childmenu-nav-link" key={subIndex}>
                                             <Link
                                                className={`${regexUrlMatch(subItem.match, location.pathname) && "app-messaging-first--childmenu-nav-link-item--active"}`}
                                                to={subItem.href}>
                                                <div className="app-messaging-first--childmenu-nav-link-item">
                                                   {subItem.name}
                                                </div>
                                             </Link>
                                          </li>
                                       )
                                    })}
                                 </ul>
                              }
                           </div>
                        </li>
                     )
                  })}
               </ul>
            </div>
         }
      </React.Fragment>
   )
}


const mapStateToProps = (state) => {
   const { subMenus } = state;
   return {
      subMenus
   };
};

export default connect(mapStateToProps, {})(SubMenu);